import { previousLineups } from "../data/lineup";
import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import styles from "./PreviousLineups.module.css";

const subNav = [
  { label: "2026 Lineup", path: "/lineup", end: true },
  { label: "Previous Lineups", path: "/lineup/previous" },
];

export default function PreviousLineups() {
  return (
    <>
      <PageHero
        eyebrow="Years on the river"
        title="Previous Lineups"
        lede="Every poster from every year. Old friends, old crowds, old dust on the boots."
        image="/photos/festival-2.jpg"
      />
      <SubNav items={subNav} />
      <Page>
        <div className={styles.grid}>
          {previousLineups.map((y) => (
            <figure key={y.year} className={styles.card}>
              <a href={y.poster} target="_blank" rel="noopener" className={styles.posterLink}>
                <img src={y.poster} alt={`${y.year} lineup poster`} loading="lazy" />
              </a>
              <figcaption className={styles.cap}>{y.year}</figcaption>
            </figure>
          ))}
        </div>
      </Page>
    </>
  );
}
